/**
 * API 入口文件
 * 整合公共 API (kjqk-commons) 和本地 API (src/api/modules)
 */
import {
  ProjectConfig as CommonConfig,
  getItem,
  setItem,
  decode,
  encode
} from 'kjqk-commons/src/common/index.js'

import { Get, Post, Put, Delete, resolveUrl } from './request'

/** 解析 increment 模块中带 url 的接口配置（仅 das-manager → yxh-das-api） */
function resolveIncrementModuleConfig(mod) {
  const resolved = { name: mod.name }
  Object.keys(mod).forEach((key) => {
    if (key === 'name') return
    const api = mod[key]
    if (api && typeof api.url === 'string') {
      resolved[key] = { ...api, url: resolveUrl(api.url) }
    } else {
      resolved[key] = api
    }
  })
  return resolved
}

// 自动加载本地 API 模块
const localConfig = {}
const requireContext = require.context('./modules', true, /\.js$/)

requireContext.keys().forEach((key) => {
  const mod = requireContext(key).default
  if (mod && mod.name) {
    localConfig[mod.name] =
      mod.name === 'increment' ? resolveIncrementModuleConfig(mod) : mod
  }
})

// 本地配置优先，实现覆盖或扩展
const ProjectConfig = {
  ...CommonConfig,
  ...localConfig
}

export {
  Get,
  Post,
  Put,
  Delete,
  resolveUrl,
  ProjectConfig,
  getItem,
  setItem,
  decode,
  encode
}

export default ProjectConfig
